import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import RunningSheetLoadDialog from "@/components/RunningSheetLoadDialog";
import { toast } from "sonner";

// Reuse the daily-sheet get-or-create and load APIs; never increment Dispatch counters.
export default function DispatchLoadDialog({ run, onClose, onSaved }) {
  const { user } = useAuth();
  const retryKey = `driver-load:${user.org_id}:${user.id}:${run.id}`;
  const sheetRef = useRef(undefined);
  if (sheetRef.current === undefined) {
    try { sheetRef.current = sessionStorage.getItem(`${retryKey}:sheet`) || null; }
    catch { sheetRef.current = null; }
  }
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    let active = true;
    api.get("/jobs").then(({ data }) => {
      if (active) setJobs((Array.isArray(data) ? data : data?.items || []).filter(j => j.status !== "completed"));
    }).catch(() => {});
    return () => { active = false; };
  }, []);
  const save = async payload => {
    if (!run.truck_id) throw new Error("Ask the office to assign a truck before logging this load.");
    if (!sheetRef.current) {
      const { data: sheet } = await api.post("/truck-sheets", {
        date: run.date, truck_id: run.truck_id, dispatch_id: run.id,
      });
      sessionStorage.setItem(`${retryKey}:sheet`, sheet.id);
      sheetRef.current = sheet.id;
    }
    await api.post(`/truck-sheets/${sheetRef.current}/loads`, payload);
    sessionStorage.removeItem(`${retryKey}:sheet`);
    toast.success("Load recorded", { description: [payload.tonnes != null ? `${payload.tonnes} t` : null, payload.cubic_m != null ? `${payload.cubic_m} m³` : null, payload.docket_number ? `Docket ${payload.docket_number}` : null].filter(Boolean).join(" · ") });
    onSaved();
  };
  return <RunningSheetLoadDialog retryStorageKey={retryKey} jobs={jobs} dispatch={run} onClose={onClose} onSave={save} />;
}
